// extracted by mini-css-extract-plugin
export default {"footer":"login_modal_footer-module__footer--2Z16r"};